import { useMutation } from '@apollo/client';
import StyleItem from 'component/style_item/MyStyleItem';
import { MouseEventHandler } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { UPDATE_STYLE } from '../../graph_ql/styles/mutations';
import { ItemStatus } from '../style_detail/constant';
import './style.scss';
import { Virtual } from 'swiper/modules';

interface IMyStyleStylistProps {
    itemType?: string;
    handleClickStyleItem: any;
    heightContent?: any;
    setSwiperInstance?: any;
    handleTrackView?: any;
    listStyle?: any;
    isSearch?: any;
    userDetail?: any;
    inputSearch?: any;
    setListDataStyle: any;
    handleChangeSlide?: any;
    handleViewInfo?: any;
    handleClick?: any;
    isItemOnly?: boolean;
    handleViewFeedbacks?: MouseEventHandler<HTMLDivElement>;
}

const MyStyleItem = ({
    handleClickStyleItem,
    heightContent,
    setSwiperInstance,
    listStyle,
    setListDataStyle,
    handleChangeSlide,
    handleViewInfo,
    handleClick,
    isItemOnly,
    handleViewFeedbacks,
}: IMyStyleStylistProps) => {
    const [updateStyleMutation] = useMutation(UPDATE_STYLE, {
        onCompleted(response) {
            const editedStyle = response.updateStyle;
            const tempListStyle = listStyle.map((item) =>
                item.taffiId === editedStyle.taffiId
                    ? {
                        ...item,
                        status: editedStyle.status,
                    }
                    : item,
            );
            setListDataStyle(tempListStyle);
        },
        onError: (err) => {
            console.error(err);
        },
    });

    const handleStyleStatus = async (item, newStatus: ItemStatus) => {
        const status = item.status === ItemStatus.Published ? ItemStatus.Unpublished : ItemStatus.Published;
        const variables = {
            input: {
                id: item.id,
                status: newStatus || status,
            },
        };
        await updateStyleMutation({ variables });
    };

    return (
        <div>
            <div
                className="itemRecommend-slider"
                style={{
                    maxHeight: `${heightContent}px`,
                    overflow: ' hidden',
                }}
            >
                <Swiper
                    direction="vertical"
                    modules={[Virtual]}
                    virtual
                    height={heightContent}
                    onSlideChange={handleChangeSlide}
                    onSwiper={setSwiperInstance}
                    mousewheel={true}
                >
                    {listStyle &&
                        listStyle.length > 0 &&
                        listStyle.map((item, index) => {
                            return (
                                <SwiperSlide key={`${item.id}_${index}`} virtualIndex={index}>
                                    <StyleItem
                                        styleItemData={
                                            isItemOnly ? { items: [{ data: item, id: item.id }], ...item } : item
                                        }
                                        heightContent={heightContent}
                                        handleViewDetail={() => null}
                                        handleClick={handleClick}
                                        handleAddtobag={() => null}
                                        handleViewInfo={handleViewInfo}
                                        handleSendMessageWA={() => null}
                                        setTitle={() => null}
                                        handleClickStyle={handleClickStyleItem}
                                        handleStyleStatus={handleStyleStatus}
                                        handleClickStylist={() => null}
                                        isItemOnly={isItemOnly}
                                        handleViewFeedbacks={handleViewFeedbacks}
                                    />
                                </SwiperSlide>
                            );
                        })}
                </Swiper>
            </div>
        </div>
    );
};

export default MyStyleItem;
